// eslint-disable-next-line import/no-extraneous-dependencies
import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: 'https://d2624eeb8e80c64373a6dec46b35563a@o1223220.ingest.us.sentry.io/4507338053255168',
  environment: process.env.SENTRY_ENV,
  release: process.env.BITBUCKET_COMMIT,
  ignoreErrors: ["TypeError: Cannot read properties of undefined (reading 'x')"],
  enabled: process.env.BITBUCKET_COMMIT !== undefined,
  integrations: [Sentry.browserTracingIntegration()],
  sampleRate: Number(process.env.SENTRY_SAMPLE_RATE_WEBAPP_SHARED_PHOTOS) || 0.01,
  tracesSampleRate: Number(process.env.SENTRY_TRACE_SAMPLE_RATE_WEBAPP_SHARED_PHOTOS) || 0.001,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});
